export const REGION_PREFERENCE_COOKIE = 'region-preference';

export interface RegionPreference {
  language: string;
  country: string;
}

export const regionCookieOptions = {
  path: '/',
  sameSite: 'lax' as const
};

export const encodeRegionPreference = (preference: RegionPreference): string =>
  `${preference.language.toLowerCase()}-${preference.country.toUpperCase()}`;

export const parseRegionPreference = (value: string | undefined): RegionPreference | undefined => {
  if (!value) return undefined;

  const delimiter = value.includes('-') ? '-' : '_';
  const [language, country] = value.split(delimiter);
  if (!language || !country) return undefined;

  return {
    language: language.toLowerCase(),
    country: country.toUpperCase()
  };
};
